import { useDispatch, useSelector } from 'react-redux';
import {
  selectIsRequestVideoDialogOpen,
  setRequestVideoDialogOpen,
} from '../../../redux/slicers/admin/curatorSlicer';
import { HubspotFormModal } from '../../../common/HubspotFormModal';

export const RequestVideoDialog = () => {
  const dispatch = useDispatch();
  const open = useSelector(selectIsRequestVideoDialogOpen);

  return (
    <HubspotFormModal
      title="Request Video"
      portalId="6917454"
      formId="2a861283-5386-47b1-a5f0-429b8e3f21c2"
      open={open}
      onClose={() => dispatch(setRequestVideoDialogOpen(false))}
    />
  );
};
